import { generateCardForCategory } from "../admin/category_utils";
//import { ajaxErrorPopUp } from "../utils/alerts";
import { JsPaginationController } from "../utils/pagination";

const paginationController = new JsPaginationController("nav ul.pagination", () => {}, 0, 5);
const CATEGORIES_PER_PAGE = 8;

function hideAllContainersBut(type) {
    document.querySelectorAll(`#categoriesContainer div[data-container-type]:not([data-container-type='${type}'])`).forEach(e => e.classList.toggle("d-none", true));
    document.querySelectorAll(`#categoriesContainer div[data-container-type='${type}']`).forEach(e => e.classList.toggle("d-none", false));
}

async function fetchCategories(page = 1){
    hideAllContainersBut("loading");

    const params = new URLSearchParams();
    params.set("page", page);
    params.set("pageSize", CATEGORIES_PER_PAGE);

    const urlStr = document.querySelector("#categoriesContainer [data-categories-api]").dataset.categoriesApi;
    const url = new URL(urlStr, window.location.origin);
    url.search = params;

    try{
        const resp = await fetch(url);
        const data = await resp.json();

        if(!resp.ok){
            console.error("Error getting categories", resp.status, resp.statusText);
            // Commented out the alert: I think it's a better experience for the user if we don't show an error if we fail to get the categories, 
            //                  just fall back to showing the "nodata" container..
            //ajaxErrorPopUp(resp.status, data.detail, data.title);
            hideAllContainersBut("nodata");
            return;
        }

        const cardContainer = document.querySelector("#categoriesContainer [data-container-type='data'] #categoryCards");
        if(!cardContainer){
            console.log("No card container found..");
            hideAllContainersBut("nodata");
            return;
        }

        const totalPages = Math.ceil(data.total / CATEGORIES_PER_PAGE);
        if(paginationController.totalPages !== totalPages){
            paginationController.updateTotal(totalPages);
        }

        cardContainer.innerHTML ="";
        
        data.results.forEach(cat => cardContainer.appendChild(generateCardForCategory(cat)));
        hideAllContainersBut("data");
    }catch(e){
        // TODO: Notify the user... idk
        console.error(e);
        hideAllContainersBut("nodata");
    }
}

window.addEventListener("DOMContentLoaded", async function(e){
    await fetchCategories();


    paginationController.updateOnPageSelect(async function(newPageNumber){
        await fetchCategories(newPageNumber);
    });

});